import { Order } from './ReportService';
import * as React from 'react';
import { ReportData } from '../../model/reportData';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import TableSortLabel from '@mui/material/TableSortLabel';
import Box from '@mui/material/Box';
import { visuallyHidden } from '@mui/utils';
import { useMediaQuery } from 'react-responsive';
import { HeadCell } from '../../model/report-fields';

interface TableHeaderProps {
  onRequestSort: (
    event: React.MouseEvent<unknown>,
    property: keyof ReportData
  ) => void;
  order: Order;
  orderBy: string;
  rowCount: number;
  headCells: HeadCell[];
  quarantineFix?: boolean;
}

export function SortableTableHeader({
  order,
  orderBy,
  onRequestSort,
  headCells,
  quarantineFix
}: TableHeaderProps) {
  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 900px)' });

  const createSortHandler =
    (property: keyof ReportData) => (event: React.MouseEvent<unknown>) => {
      onRequestSort(event, property);
    };

  return (
    <TableHead>
      <TableRow style={{ height: 60 }}>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            data-testid="tableHeader"
            align={'center'}
            padding={isTabletOrMobile ? 'none' : 'normal'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <Box component='span' sx={visuallyHidden}>
                  {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
        {quarantineFix && <TableCell data-testid="tableHeader"
          align={'center'}
          padding={isTabletOrMobile ? 'none' : 'normal'}>Select Event</TableCell>}
      </TableRow>
    </TableHead>
  );
}
